import { innerHTML, queryAll, queryOne, touchAll } from 'lambda-dom'

// ------------------------------------------------------------------------------
//      All Available Languages
// ------------------------------------------------------------------------------

const getLanguageFullName = (lang: string): string => {
    const languages: { [key: string]: string } = {
        'EN': 'English',
        'NL': 'Nederlands',
        'PL': 'Polski',
        'DE': 'Deutsch',
        'FR': 'Français',
        'CN': '中文',
        'RU': 'русский',
        'ES': 'Español',
        'IT': 'Italiano',
        'HU': 'Magyar',
        'SE': 'Svenska',
        'DK': 'Dansk',
    }

    return languages[lang]
}

// ------------------------------------------------------------------------------
//      Language Specific Filtering Buttons
// ------------------------------------------------------------------------------

const codeOfConductButtons = queryAll('.code-of-conduct--content__button')
const codeOfConductDownloads = queryAll('.code-of-conduct--content__downloads')
const speakUpDownloadTexts = queryAll('.disabled-speakup-download-text')

const switchActiveDownloadGroup = (downloadSet: string) => {
    codeOfConductDownloads.forEach(codeOfConductDownload => {
        codeOfConductDownload.classList.remove('active')
    })

    codeOfConductButtons.forEach(codeOfConductButton => {
        codeOfConductButton.classList.remove('active')
    })

    const activeCodeOfConductDownload = queryOne(`.code-of-conduct--content__downloads-${downloadSet}`)
    activeCodeOfConductDownload?.classList?.add('active')

    const activeCodeOfConductButton = queryOne(`.code-of-conduct--content__button-${downloadSet}`)
    activeCodeOfConductButton?.classList?.add('active')

    speakUpDownloadTexts.forEach((speakUpDownloadText) => {
        speakUpDownloadText.classList.remove('active')
    })
}

codeOfConductButtons.forEach(codeOfConductButton => {
    const downloadSet = codeOfConductButton.id!
    codeOfConductButton.addEventListener('click', () => switchActiveDownloadGroup(downloadSet))
})

// ------------------------------------------------------------------------------
//      Language Selector
// ------------------------------------------------------------------------------

touchAll([
    '#code-of-conduct--heading__language-active',
    '#code-of-conduct--heading__language-dropdown',
], (
    activeLanguage: HTMLElement,
    dropDown: HTMLElement,
) => {
    const dropDownLanguages = queryAll('.language-dropdown--item')
    const codeOfConductContents = queryAll('.code-of-conduct--content')

    const switchActiveLanguage = (lang: string) => {
        const activeLanguageElement = queryOne('#code-of-conduct--heading__language-active')!

        innerHTML(`${getLanguageFullName(lang)} <div class="arrow-down"></div>`)(activeLanguageElement)

        dropDown.classList.remove('active')

        codeOfConductContents.forEach(codeOfConductContent => {
            codeOfConductContent.classList.remove('active')
        })

        const activeLanguageContent = queryOne(`.code-of-conduct--content-${lang}`)
        activeLanguageContent?.classList?.add('active')

        switchActiveDownloadGroup(`${lang}-1`)
    }

    activeLanguage.addEventListener('mouseover', () => dropDown.classList.add('active'))
    activeLanguage.addEventListener('mouseleave', () => dropDown.classList.remove('active'))
    dropDown.addEventListener('mouseover', () => dropDown.classList.add('active'))
    dropDown.addEventListener('mouseleave', () => dropDown.classList.remove('active'))

    switchActiveLanguage('EN')

    dropDownLanguages.forEach(dropDownLanguage => {
        const lang = dropDownLanguage.getAttribute('data-language')!

        dropDownLanguage.addEventListener('click', () => switchActiveLanguage(lang))
        innerHTML(`${getLanguageFullName(lang)}`)(dropDownLanguage)
    })
})

// ------------------------------------------------------------------------------
//      Init
// ------------------------------------------------------------------------------

switchActiveDownloadGroup('EN-1')
